import {
	OnboardingUserAppContextType,
	useOnboardingUserContext,
} from '../../../store'
import EditProfileComponent from '../../../components/profile-component/EditProfileComponent'
import React from 'react'
import { Grid } from '@adsk/alloy-react-box'
import Theme from '@adsk/alloy-react-theme'
import { LinkButton } from '@adsk/alloy-react-button'
import ReadOnlyProfileComponent from '../../../components/profile-component/ReadOnlyProfileComponent'
import { track } from '@adsk/acs-web-analytics'
import ANALYTICS_TYPES from '../../../types/AnalyticsTypes'
import { getPackageInfo } from '../../../utils'
import ReadOnlyProfileLoaderComponent from '../../../components/profile-component/ReadOnlyProfileLoaderComponent'
import { useTranslation } from '../../../../i18n'
import { isBCNonGhostUser } from '../../../utils/helpers'

const BodyComponent = (): JSX.Element => {
	const { version, name } = getPackageInfo()
	const {
		state: { profileReadOnlyMode, showLoader, userInfo, config },
	} = useOnboardingUserContext() as OnboardingUserAppContextType
	const { typography, spacing } = Theme
	const { t } = useTranslation()
	const isBcNonGhostUser = isBCNonGhostUser(userInfo)
	return (
		<>
			{showLoader && <ReadOnlyProfileLoaderComponent />}
			{!showLoader && (
				<Grid gridGap={2}>
					<span
						data-testid={'profile-message'}
						style={{
							marginBottom: spacing.small,
							...(isBcNonGhostUser ? typography.heading5 : typography.heading4),
						}}
					>
						{isBcNonGhostUser
							? t('LINKED_BC_ACCOUNT_MESSAGE')
							: t('VIEW_PROFILE_BODY')}
						<LinkButton
							onClick={() => {
								track(ANALYTICS_TYPES.NAPI_USERS_CLICKED_STATIC_LINK, {
									package: name,
									component: `ReadOnlyProfile.${BodyComponent.name}`,
									version,
									linkText: t('CLICK_TO_LEARN_MORE'),
									link: config?.LEARN_MORE,
								})
								window.open(config?.LEARN_MORE, '_blank')
							}}
						>
							{' '}
							<b
								style={{
									...(isBcNonGhostUser
										? typography.heading5
										: typography.heading4),
									paddingLeft: spacing.xxxSmall,
								}}
							>
								{t('CLICK_TO_LEARN_MORE')}
							</b>
						</LinkButton>
					</span>
					{profileReadOnlyMode ? (
						<ReadOnlyProfileComponent />
					) : (
						<EditProfileComponent />
					)}
				</Grid>
			)}
		</>
	)
}

export default BodyComponent
